export default __webpack_public_path__ + "static/media/07_Business-PortraitArchitecture-InteriorEschweilerPhotography_M1A7661.43acfba3.jpg";